var Marionette = require('backbone.marionette');

var ReviewerFormView = require('../review/reviewer-form-view');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');

var AssignReviewersForm = Marionette.View.extend({
    template: require('../../templates/documents/assign-reviewers-form.html'),

    regions: {
    },

    ui: {
        modal: '#addReviewersModal',
        reviewers: '.reviewers-review',
        saveReviewers: '#save',
        addReviewer: '.add-reviewer'
    },

    events: {
        'click @ui.addReviewer': 'addReviewer',
        'click @ui.saveReviewers': 'saveReviewers'
    },

    childViewEvents: {
        'reviewer:will-be-remove': 'reviewerRemove',
        'reviewer:changed': 'onReviewerChanged'
    },

    initReviewer: function () {
        return {
            personId: "",
            organizationId: "",
            mandatory: true
        }
    },

    initialize: function (options) {
        var that = this;
        that.reviewers = [];
        that.utils = new CommonUtils();
        that.docIds = options.docIds;
    },

    onRender: function () {
        var that = this;
        that.show();
    },

    addReviewer: function () {
        var reviewer = this.initReviewer();
        this.reviewers.push(reviewer);
        var newRegionId = _.uniqueId('reviewer');
        this.ui.reviewers.append('<div id="' + newRegionId + '"></div>');
        this.addRegion(newRegionId, "#" + newRegionId);
        this.storeRegion(newRegionId);
        this.showChildView(newRegionId, new ReviewerFormView({
            reviewer: reviewer,
            regionId: newRegionId
        }));

        this.checkReviewers();
    },

    reviewerRemove: function (data) {
        var that = this;
        var regionId = data.regionId;
        var reviewer = data.reviewer;
        that.getRegion(regionId).empty();
        that.removeRegion(regionId);
        that.$('#' + regionId).remove();
        this.tempRegionNames = this.tempRegionNames.filter(function (item) {
            return item !== regionId;
        });
        that.reviewers = that.reviewers.filter(function (item) {
            return item !== reviewer;
        });
        that.checkReviewers();
    },

    saveReviewers: function () {
        if (this.reviewers.length == 0 || this.docIds == [] || _.isEmpty(this.docIds))
            return;

        var that = this;
        that.utils.showSpinner('#add-reviewers-loader');
        $.ajax({
            type: "POST",
            url: '/api/document/multi/' + that.docIds.join() + '/reviewers',
            data: JSON.stringify(that.reviewers),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner('#add-reviewers-loader');
                    that.reviewersSaved();
                    that.triggerMethod('reviewers:added:to:document');
                }
            },
            error: function(e) {
                that.utils.hideSpinner('#add-reviewers-loader');
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },

    reviewersSaved: function() {
        var that = this;
        if (that.tempRegionNames) {
            that.tempRegionNames.forEach(function (item) {
                that.getRegion(item).empty();
                that.removeRegion(item);
                that.$('#' + item).remove();
            });
        }
        that.tempRegionNames = [];
        that.reviewers = [];
        that.hide();
    },

    deleteRegion: function (regionId) {
        this.getRegion(regionId).empty();
        this.removeRegion(regionId);
        this.$('#' + regionId).remove();
    },

    storeRegion: function (regionName) {
        this.tempRegionNames = this.tempRegionNames || [];
        this.tempRegionNames.push(regionName);
    },

    show: function() {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function() {
        this.ui.modal.modal('hide');
    },

    onReviewerChanged: function() {
        this.checkReviewers();
    },

    checkReviewers: function() {
        var that = this;
        if (that.reviewers.filter(function(reviewer) {
                return reviewer.organizationId || reviewer.personId;
            }).length == that.reviewers.length)
            that.ui.saveReviewers.removeAttr('disabled');
        else
            that.ui.saveReviewers.attr('disabled', true);
    }
});

module.exports = AssignReviewersForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/assign-reviewers-form.js
// module id = 439
// module chunks = 0